<template>
  <tr>
    <td class="font-semibold flex flex-col justify-start items-start">
      <div>
        <img
          :src="getIconPath(coin.icon)"
          alt="icon"
          class="w-6 h-6 inline-block mr-2"
        />
        {{ coin.name }}
      </div>
      <div class="flex justify-between items-center gap-x-2">
        <button
          type="button"
          class="text-xs border rounded px-2"
          @click="$emit('modal-open', 'mt', coin.name + 'USDT')"
        >
          {{ coinConfig?.marginType }}
        </button>
        <button
          class="flex w-full border rounded overflow-hidden"
          @click="$emit('modal-open', 'lvg', coin.name + 'USDT')"
        >
          <div class="text-xs font-bold px-1">{{ coinConfig?.leverage }}x</div>
        </button>
      </div>
    </td>

    <td>
      <button
        class="px-2 py-1 text-white border rounded"
        :class="{
          'bg-gray-400': manualControl === 1,
          'bg-gray-200': manualControl === 0,
        }"
        :disabled="manualControl === 0"
        @click="
          $emit(
            'action',
            'start',
            buyConfig.config?.tradeId,
            GT_IS_LONG ? 'long' : 'short',
            coin.name + 'USDT'
          )
        "
      >
        <i class="icon-play"></i>
        거래
      </button>
      <button
        class="px-2 py-1 text-white rounded ml-2"
        :class="{
          'bg-gray-600': curPositionAsset.isExist && manualControl === 0,
          'bg-gray-200': !curPositionAsset.isExist || manualControl === 1,
        }"
        :disabled="!curPositionAsset.isExist || manualControl === 1"
        @click="
          $emit(
            'action',
            'stop',
            buyConfig.config?.tradeId,
            GT_IS_LONG ? 'long' : 'short',
            coin.name + 'USDT'
          )
        "
      >
        <i class="icon-pause"></i>
        중지
      </button>
      <button
        class="px-2 py-1 text-white rounded ml-2"
        :class="{
          'bg-gray-900': curPositionAsset.isExist,
          'bg-gray-200': !curPositionAsset.isExist,
        }"
        :disabled="!curPositionAsset.isExist"
        @click="
          $emit(
            'action',
            'sell',
            buyConfig.config?.tradeId,
            GT_IS_LONG ? 'long' : 'short',
            coin.name + 'USDT'
          )
        "
      >
        <i class="icon-stop"></i>
        매도
      </button>
      <!-- <button class="ml-2">
        <span
          class="text-xl font-bold"
          @click="checkConfigState(coin.name + 'USDT', GT_IS_LONG)"
          >&#10227;</span
        >
      </button> -->
    </td>

    <!-- 매수 설정 -->
    <TableSingleButton
      :label="curBcStep?.cnt"
      :value="buyConfig?.config?.buyTriggerPercent || '-'"
      @click="$emit('modal-open', 'buy', coin.name + 'USDT')"
    />
    <!-- 매도 값-->
    <TableSingleButton
      :value="buyConfig?.config?.takeProfitPercent || '-'"
      :subText="
        curBcStep.profit?.triggerPrice && coinConfig?.pricePrecision
          ? convertPriceFloor(
              curBcStep.profit?.triggerPrice,
              coinConfig?.pricePrecision
            )
          : null
      "
      :reqStats="buyConfig?.profit?.reqStats"
      @click="
        buyConfig?.profit?.reqStats === 'FAILED'
          ? $emit('modifyTrigger', 'tp', coin.name)
          : null
      "
    />
    <!-- 매수 중지 값-->
    <TableSingleButton
      :value="buyConfig?.config?.buyStopPercent || '-'"
      :subText="
        buyConfig?.config?.buyStopPercent && coinConfig?.pricePrecision
          ? convertPriceFloor(
              buyConfig?.config?.initEntryPrice *
                (GT_IS_LONG
                  ? 1 -
                    (buyConfig?.config?.buyStopPercent / 100) *
                      (1.0 / coinConfig.leverage)
                  : 1 +
                    (buyConfig.config?.buyStopPercent / 100) *
                      (1.0 / coinConfig.leverage)),
              coinConfig?.pricePrecision
            )
          : null
      "
    />
    <!-- 강제 매도 값-->
    <TableSingleButton
      :value="buyConfig?.config?.forceCellPercent || '-'"
      :subText="
        curBcStep.force?.triggerPrice && coinConfig?.pricePrecision
          ? convertPriceFloor(
              curBcStep.force?.triggerPrice,
              coinConfig?.pricePrecision
            )
          : null
      "
      :reqStats="buyConfig?.force?.reqStats"
      @click="
        buyConfig?.force?.reqStats === 'FAILED'
          ? $emit('modifyTrigger', 'sl', coin.name)
          : null
      "
    />
    <!-- 현재가-->
    <td>
      {{ convertLocalString(markPrice) }}
    </td>
    <!-- 청산가-->
    <td class="text-orange-400">
      {{ cutNumberFloorUSDT(curPositionAsset.liqPrice) }}
    </td>
    <!-- 총 매수금액-->
    <td>{{ cutNumberFloorUSDT(curPositionAsset.totalAmount) }}</td>
    <!-- 평균 매수가-->
    <td>
      {{
        curPositionAsset.totalAvg && coinConfig?.pricePrecision
          ? convertPriceFloor(
              curPositionAsset.totalAvg,
              coinConfig.pricePrecision
            )
          : curPositionAsset.totalAvg
      }}
    </td>
    <!-- 수익 -->
    <td>
      <p
        class="text-xs"
        :class="{
          'text-red-500': curPositionAsset.unpl < 0,
          'text-green-500': curPositionAsset.unpl > 0,
        }"
      >
        {{ curPositionAsset.unpl.toFixed(2) + " USDT" }}
        <br />
        (ROI: {{ curPositionAsset.totalPl.toFixed(2) + " %" }})
      </p>
    </td>
    <td
      class="text-xs"
      :class="{
        'text-red-500':
          cumulativeP && cumulativeP.pnl + curPositionAsset.unpl < 0,
        'text-green-500':
          cumulativeP && cumulativeP.pnl + curPositionAsset.unpl > 0,
      }"
    >
      {{
        cumulativeP
          ? Math.floor(
              (cumulativeP.pnl + curPositionAsset.unpl) * Math.pow(10, 2)
            ) / Math.pow(10, 2)
          : ""
      }}
    </td>
  </tr>
</template>

<script>
import { storeName } from "@/global/variable";
import { mapGetters } from "vuex";
import TableSingleButton from "./TableSingleButton.vue";

const marketPriceStore = "markPriceStore";

const assetStore = "assetStore";
// const coreStore = "coreStore";

export default {
  name: "CoinRow",
  props: {
    coin: Object,
    buyConfig: Object,
    manualControl: Number,
    cumulativeP: Object,
  },
  components: { TableSingleButton },
  created() {
    this.symbolUSDT = this.coin.name + "USDT";
    this.symbol = this.coin.name;
  },
  computed: {
    ...mapGetters(storeName.core, ["GT_IS_LONG"]),
    //현재가
    markPrice: function () {
      return this.$store.getters[`${marketPriceStore}/${this.symbol}`];
    },
    // 각 코인별 레버리지
    coinConfig: function () {
      return this.$store.getters[`${assetStore}/ASSET_CONFIG`](this.symbolUSDT);
    },

    curBcStep: function () {
      if (
        this.buyConfig != null &&
        this.buyConfig.config != null &&
        this.buyConfig.list.length > 0
      ) {
        let targetIndex = this.buyConfig.list.findIndex(
          (f) => f.reqStats === "READY" && f.itemType === "BUY"
        );
        if (targetIndex == -1) {
          // 리스트는 있는데, 모두 체결된 경우 ,
          targetIndex = this.buyConfig.list.length - 1;
        }
        console.log(
          "--- sub --- ",
          this.buyConfig.list.find((f) => f.itemType === "PROFIT")
        );
        return {
          cnt: targetIndex,
          profit: this.buyConfig.profit,
          force: this.buyConfig.force,
        };
      } else {
        return "-";
      }
    },

    // TODO : 매도 단계
    // 현재 자산
    curPositionAsset: function () {
      // console.log(this.positionStr, this.symbolUSDT);
      const test = this.$store.getters[`${assetStore}/ASSET_COIN`](
        this.symbolUSDT,
        this.GT_IS_LONG ? "long" : "short"
      );
      const isExist = test != null || test != undefined;

      const totalAmount =
        test == null ? 0 : test?.initialMargin * (this.GT_IS_LONG ? 1 : -1);

      const totalAvg = test?.entryPrice;
      const liqPrice = test?.liquidationPrice;
      const unpl = test
        ? this.calculatePnl(
            test.positionAmt,
            1,
            this.markPrice,
            test.entryPrice
          )
        : 0;
      const totalPl = test
        ? this.calculateROI(
            test.positionAmt,
            1,
            this.markPrice,
            test.entryPrice,
            test.initialMargin
          )
        : 0;
      // console.log(this.unpl);
      return { totalAmount, totalAvg, unpl, totalPl, liqPrice, isExist };
    },
  },
  data() {
    return {
      isModalOpen: false,
      isLvgModalOpen: false,
      isSellModalOpen: false,

      modalTitle: "",
      forceConfig: {
        isModelOpen: false,
        forceType: "", // sell or stop
      },

      lastBuyStep: { step: "-", amount: "-", percent: "-" },
      lastSellStep: { step: "-", amount: "-", percent: "-" },
    };
  },
  methods: {
    getIconPath(iconAddress) {
      return require(`../assets/${iconAddress}`);
    },
    /**
     * PNL 계산
     * @param size {double} 포지션 사이즈
     * @param direction {int} long ? 1 : -1
     * @param markPrice {double} 현재가
     * @param entryPrice {double} 진입가격
     */
    calculatePnl(size, direction, markPrice, entryPrice) {
      return size * direction * (markPrice - entryPrice);
    },
    calculateROI(size, direction, markPrice, entryPrice, notional) {
      return (
        (this.calculatePnl(size, direction, markPrice, entryPrice) /
          Math.abs(notional)) *
        100
      );
    },
    cutNumberFloorUSDT(usdt) {
      if (usdt == 0) return "";
      const limit = this.coinConfig?.quantityPrecision;
      if (limit == null || usdt == null) return usdt;
      const convertValue =
        Math.floor(usdt * Math.pow(10, limit)) / Math.pow(10, limit);
      const splitMp = convertValue.toString().split(".");
      const ntValue = Number(splitMp[0]).toLocaleString("en-US");

      let resultStr = ntValue;
      if (splitMp[1]) {
        resultStr = resultStr + "." + splitMp[1];
      }

      return resultStr;
    },
    convertLocalString(mp) {
      if (mp != null && mp != undefined) {
        const splitMP = mp.split(".");
        const ntValue = Number(splitMP[0]).toLocaleString("en-US");
        return ntValue + "." + splitMP[1];
      }
    },
    convertPriceFloor(calcedValue, floor) {
      return (
        Math.floor(calcedValue * Math.pow(10, floor)) / Math.pow(10, floor)
      );
    },

    // checkConfigState(symbol, isLong) {
    //   console.log("click");
    //   // TODO :
    //   console.log(symbol, isLong);
    // },
  },
};
</script>

<style>
td .step {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #d9d9d9;
}

td .date {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

td .step {
  &.isNext {
    background: #111827;
    color: #ffffff;
  }
}
</style>
